(function ($) {
  "use strict";

  var ms2 = {
    init: function () {
      this.mainMenuBlock();
      this.mainMenuBlock1();
      this.submenuOpener();
      this.submenuOpenerFooter();
      this.stickyHeader();
      this.languageTrigger();
      this.heroSlider();
      this.customAccordion();
      this.whiteBoxSlider();
      this.whiteBoxSlider1();
      this.stackedImgTextSlider();
    },

    mainMenuBlock: function () {
      jQuery("header").on("click", ".navbar-toggle-btn", function (e) {
        e.preventDefault();
        if (!jQuery(this).hasClass("nav-open")) {
          jQuery("#navbar").removeClass("active");
          jQuery("html").removeClass("menu-active");
          jQuery(this).removeClass("nav-close").addClass("nav-open");
        } else {
          jQuery("#navbar").addClass("active");
          jQuery("html").addClass("menu-active");
          jQuery(this).removeClass("nav-open").addClass("nav-close");
        }
      });
    },

    mainMenuBlock1: function () {
      jQuery("header").on(
        "click",
        ".navbar-toggle-btn.nav-close",
        function (e) {
          jQuery("html").removeClass("submenu-active");
          jQuery(".nav-item").removeClass("opened");
          jQuery(".submenu-opener").removeClass("closed");
          jQuery(".dropdown-menu").css("display", "none");
        },
      );
    },

    submenuOpener: function () {
      jQuery("header.main-header .navbar-nav .submenu-opener").on(
        "click",
        function (e) {
          // e.preventDefault();

          const $this = jQuery(this);

          // CLOSE all other open dropdowns
          jQuery("header.main-header .navbar-nav .submenu-opener")
            .not($this)
            .removeClass("closed")
            .parent(".nav-item")
            .removeClass("opened")
            .find(".dropdown-menu")
            .slideUp();

          // TOGGLE current dropdown
          if (!$this.hasClass("closed")) {
            jQuery("html").addClass("submenu-active");

            $this.addClass("closed");
            $this.parent(".nav-item").addClass("opened");
            $this.next(".dropdown-menu").slideDown();
          } else {
            jQuery("html").removeClass("submenu-active");

            $this.removeClass("closed");
            $this.parent(".nav-item").removeClass("opened");
            $this.next(".dropdown-menu").slideUp();
          }
        },
      );
    },

    submenuOpenerFooter: function () {
      jQuery(".single-column-menu .submenu-opener").on("click", function (e) {
        e.preventDefault();

        var $this = jQuery(this);
        var $currentMenu = $this.next("ul.dropdown-menu");

        // Close all other open menus
        jQuery(".single-column-menu .submenu-opener")
          .not($this)
          .removeClass("opened")
          .next("ul.dropdown-menu")
          .slideUp();

        // Toggle current menu
        $this.toggleClass("opened");
        $currentMenu.slideToggle();
      });
    },

    stickyHeader: function () {
      jQuery(function () {
        function toggleStickyHeader() {
          var sticky = jQuery("header"),
            scroll = jQuery(window).scrollTop();

          if (scroll >= 1) {
            sticky.addClass("sticky-header");
          } else {
            sticky.removeClass("sticky-header");
          }
        }

        jQuery(window).on("scroll", toggleStickyHeader);
        toggleStickyHeader(); // Trigger once on page load
      });
    },

    languageTrigger: function () {
      jQuery(".language-selector-trigger").on("click", function () {
        var $parent = jQuery(this).closest(".language-selector");

        // Toggle the submenu within the same language selector
        $parent.find(".sub-menu").slideToggle();

        // Toggle rotation on the trigger
        jQuery(this).toggleClass("rotate");

        // Toggle 'opened' class on the parent
        $parent.toggleClass("opened");
      });
    },

    heroSlider: function () {
      var $mainslider = $(".hero-slider");

      // Slick Slider Options
      $mainslider.slick({
        draggable: true,
        arrows: true,
        dots: false,
        fade: true,
        infinite: true,
        speed: 300,
        mobileFirst: true,
        pauseOnHover: true,
      });
    },

    customAccordion: function () {
      $(".Accordions").each(function () {
        var $accordion = $(this);

        // Ensure all items are closed on load
        $accordion.find(".inner_content").hide();
        $accordion.find(".title_tab").removeClass("active");

        // Click handler for only this accordion
        $accordion.find(".title_tab").on("click", function (e) {
          e.preventDefault();
          var $this = $(this);

          if ($this.hasClass("active")) {
            $this.removeClass("active").next().stop().slideUp(500);
          } else {
            $this.addClass("active").next().stop().slideDown(500);

            $this
              .parent()
              .siblings()
              .children(".title_tab")
              .removeClass("active");
            $this
              .parent()
              .siblings()
              .children(".inner_content")
              .stop()
              .slideUp(500);
          }
        });
      });
    },

    whiteBoxSlider: function () {
      mobileOnlySlider(".white-box-slider", true, true, 767);

      function mobileOnlySlider($slidername, $dots, $arrows, $breakpoint) {
        var slider = $($slidername);
        var settings = {
          mobileFirst: true,
          dots: $dots,
          arrows: $arrows,
          autoplay: false,
          infinite: true,
          slidesToShow: 1,

          responsive: [
            {
              breakpoint: $breakpoint,
              settings: "unslick",
            },
          ],
        };

        slider.slick(settings);

        $(window).on("resize", function () {
          if ($(window).width() > $breakpoint) {
            return;
          }
          if (!slider.hasClass("slick-initialized")) {
            return slider.slick(settings);
          }
        });
      } // Mobile Only Slider
    },

    whiteBoxSlider1: function () {
      mobileOnlySlider(".white-box-slider1", true, true, 991);

      function mobileOnlySlider($slidername, $dots, $arrows, $breakpoint) {
        var slider = $($slidername);

        var settings = {
          mobileFirst: true,
          dots: $dots,
          arrows: $arrows,
          autoplay: false,
          infinite: true,
          slidesToShow: 1,

          responsive: [
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 2,
              },
            },
            {
              breakpoint: $breakpoint,
              settings: "unslick",
            },
          ],
        };

        slider.slick(settings);

        $(window).on("resize", function () {
          if ($(window).width() > $breakpoint) {
            return;
          }
          if (!slider.hasClass("slick-initialized")) {
            return slider.slick(settings);
          }
        });
      }
    },

    stackedImgTextSlider: function () {
      var $sliders = $(".stacked-img-text-slider");

      // init slider function
      function initSlider($slider) {
        $slider.slick({
          dots: true,
          infinite: false,
          speed: 300,
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: true,
          responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 2,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                infinite: true,
              },
            },
          ],
        });
      }

      // 🔑 arrow positioning function
      function setArrowPosition($slider) {
        var $firstImg = $slider
          .find(".slick-slide.slick-active .img-container")
          .first();

        if ($firstImg.length) {
          var imgHeight = $firstImg.outerHeight();

          $slider.find(".slick-arrow").css({
            top: imgHeight / 2 + "px",
            // transform: "translateY(-50%)",
          });
        }
      }

      // init all sliders on load
      $sliders.each(function () {
        initSlider($(this));
      });

      // bind arrow positioning events (IMPORTANT: bind BEFORE init OR use on())
      $sliders.on("init setPosition afterChange", function () {
        setArrowPosition($(this));
      });

      // update on resize
      $(window).on("resize", function () {
        $sliders.each(function () {
          setArrowPosition($(this));
        });
      });

      // button click (scoped per section)
      $(".show-more").on("click", function (e) {
        e.preventDefault();

        var $btn = $(this);
        var $section = $btn.closest("section");
        var $slider = $section.find(".stacked-img-text-slider");

        if ($slider.hasClass("slick-initialized")) {
          $slider.slick("unslick");
          $btn.text("Visa färre");
        } else {
          initSlider($slider);
          $btn.text("Visa alla");
        }
      });
    },
  };

  ms2.init();
})(jQuery);
